var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "root", staticClass: "date-picker" }, [
    _c(
      "button",
      { staticClass: "date-button date-trigger", on: { click: _vm.toggle } },
      [
        _c("img", {
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/calendar.svg?v=1670856557"
          }
        }),
        _vm._v("\n    " + _vm._s(_vm.displayText) + "\n    "),
        _c("span", { staticClass: "arrow down" })
      ]
    ),
    _vm._v(" "),
    _vm.open
      ? _c(
          "div",
          {
            staticClass: "popover",
            attrs: { role: "dialog", "aria-label": "Date picker" },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                return _vm.close($event)
              }
            }
          },
          [
            _c("div", { staticClass: "cal-header" }, [
              _c(
                "button",
                {
                  staticClass: "nav",
                  attrs: { "aria-label": "Previous month" },
                  on: { click: _vm.prevMonth }
                },
                [_vm._v("‹")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.monthLabel))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "nav",
                  attrs: { "aria-label": "Next month" },
                  on: { click: _vm.nextMonth }
                },
                [_vm._v("›")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cal-grid" },
              [
                _vm._l(_vm.dow, function(d) {
                  return _c("div", { key: d, staticClass: "dow" }, [
                    _vm._v(_vm._s(d))
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.cells, function(cell) {
                  return _c(
                    "div",
                    {
                      key: cell.key,
                      staticClass: "cell",
                      class: {
                        "is-out": cell.isOtherMonth,
                        "is-disabled": cell.disabled,
                        "is-selected": _vm.isSameDay(
                          cell.dateObj,
                          _vm.selectedDateObj
                        )
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "daybtn",
                          attrs: {
                            disabled: cell.disabled,
                            "aria-label": _vm.formatAria(cell.dateObj)
                          },
                          on: {
                            click: function($event) {
                              return _vm.pick(cell.dateObj)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(cell.day) + "\n        "
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }